import { Benefit, BenefitFilter } from '@witkac/kartamiejska-shared';
import {
  BenefitResource,
  benefitResource
} from '@witkac/kartamiejska-resources';

import store from '@/store/store';
import { EntityModule } from './entity.module';

/**
 * Moduł usług partnera
 *
 * @export
 * @class BenefitsModule
 * @extends {AbstractModule<BenefitResource>}
 */
export class BenefitsModule extends EntityModule<Benefit, BenefitResource> {
  public actions = {
    /**
     * Logowanie
     *
     * @param context context
     * @param data dane logowania
     */
    userBenefits: async (
      context: any,
      filter: BenefitFilter = {}
    ): Promise<void> => {
      const response = await this.resource.userBenefits(filter);
      context.commit('saveList', response.list);
      context.commit('saveCount', response.count);
    }
  };
  constructor() {
    super(benefitResource);
    this.mutations = {
      ...this.mutations
    };
  }
}

export default new BenefitsModule();
